import React from 'react';

interface Props {
  onClick: () => void;
}

const SimpleLayer: React.FC<Props> = ({ onClick }: Props) => {
  return <div className="simple-layer" onClick={onClick} />;
};

export default SimpleLayer;
